import { defineStore } from 'pinia'
import api from '../services/api'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(JSON.parse(localStorage.getItem('user')))
  const loading = ref(false)
  const error = ref(null)

  async function login(email, password) {
    loading.value = true
    error.value = null
    try {
      const formData = new FormData()
      formData.append('username', email)
      formData.append('password', password)
      
      const response = await api.post('/token', formData)
      const { access_token } = response.data
      localStorage.setItem('token', access_token)
      
      const userResponse = await api.get('/users/me')
      user.value = userResponse.data
      localStorage.setItem('user', JSON.stringify(user.value))
      
      return user.value
    } catch (e) {
      error.value = e.response?.data?.detail || e.message
      throw e
    } finally {
      loading.value = false
    }
  }

  function logout() {
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }

  return { user, loading, error, login, logout }
})
